import { render } from "./RssFeedDisplayPanel.vue?vue&type=template&id=35fbb27b"
import script from "./RssFeedDisplayPanel.vue?vue&type=script&lang=js"
export * from "./RssFeedDisplayPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__